document.addEventListener("DOMContentLoaded", () => {
  const MAPBOX_KEY =
    "pk.eyJ1IjoibWFuYXdlYiIsImEiOiJja2xuMmJqdTYwZXV5MndwNDNrcWhrZHNnIn0.ODueglugOVNtTTl-ccuEkg";

  const mapState = {
    lng: -73.55249779,
    lat: 45.505331312,
  };
  let choosenPath = 0;

  const greenIcon = typeof L !== 'undefined' ? L.icon({
    iconUrl: directory_uri ? `${directory_uri.WS_WP_TEMPLATE_URL}/sources/img/pin-home.png` : '',
    iconSize:     [70, 95], // size of the icon
    shadowSize:   [50, 64], // size of the shadow
    iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
    shadowAnchor: [4, 62],  // the same for the shadow
    popupAnchor:  [-3, -76] //
  }) : null;
  let mymap, mymarker;
  let fieldId;

  function onInitMap() {
    const fieldId = document.querySelector(".radio_paths ul.gfield_radio")? document.querySelector(".radio_paths ul.gfield_radio").id:0;
    if (document.querySelector("#mapid")) {
      setMap();
    }

    const btnCoordinate = document.querySelector("#getlonglat");
    btnCoordinate.addEventListener("click", (event) => {
      getlonglat();
    });

    const btnCoordinateaddress = document.querySelector("#getlonglatByAddress");
    btnCoordinateaddress.addEventListener("click", (event) => {
      getlonglatByAddress();
    });
  }

  function setMap() {
    if (mymap !== undefined) {
      mymap.off();
      mymap.remove();
    }
    mymap = L.map("mapid");
    mymap.setView([mapState.lat, mapState.lng], 13);
    mymap.scrollWheelZoom.disable();

    const tileLayer = L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=" +
        MAPBOX_KEY,
      {
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18,
        id: "mapbox/streets-v11",
        tileSize: 512,
        zoomOffset: -1,
      }
    );
    

    tileLayer.addTo(mymap);
    mymarker = L.marker([mapState.lat, mapState.lng], {
      draggable: true,
      icon: greenIcon
    }).addTo(mymap);
    setLongLat(mapState.lng, mapState.lat);

    mymarker.on("dragend", function (e) {
      setLongLat(mymarker.getLatLng().lng, mymarker.getLatLng().lat);
    });
  }

  function onLocationFound(e) {
    if (mymarker) {
      mymarker.setLatLng(e.latlng);
    } else {
      mymarker = L.marker(e.latlng, { draggable: true }).addTo(mymap);
    }
    mymap.panTo(e);
    mymarker.on("dragend", function (e) {
      setLongLat(mymarker.getLatLng().lng, mymarker.getLatLng.lat);
    });
  }

  function locate() {
    mymap.locate({ setView: true, maxZoom: 25, enableHighAccuracy: true });
    navigator.geolocation.getCurrentPosition(function (location) {
      setLongLat(location.coords.longitude, location.coords.latitude);
    });
  }

  function getlonglat() {
    locate();
  }

  function getlonglatByAddress() {
    const address = encodeURI($("#address").val());
    $.get(
      "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
        address +
        ".json?limit=5&&language=fr&country=ca&proximity=-73.55249779,45.505331312&access_token=" +
        MAPBOX_KEY,
      function (data) {
        if (data.features && data.features.length > 1) {
          displayAllQueriesLocation(data.features);
        } else {
          setLongLat(
            data.features[0].center[0],
            data.features[0].center[1]
          );
          scrollToMap();
        }
      }
    );
  }
  function setLongLat(long, lat) {
    document.querySelector("#lat").value = lat;
    document.querySelector("#lng").value = long;
    const wrapperElement = document.querySelector(
      ".address-selection-wrapper"
    );

    // Reset the list of similar results on the bottom
    if (wrapperElement) {
      wrapperElement.innerHTML = "";
    }
    const latLng = new L.LatLng(lat, long);
    mymarker.setLatLng(latLng);

    mymap.panBy(new L.Point(-offset, 0), { animate: true });
    mymap.setView(latLng, 13);

    var offset = mymap.getSize();
    if (offset.x == 0) {
      setTimeout(() => {
        mymap.invalidateSize();
        mymap.panBy(new L.Point(-offset, 0), { animate: true });
        mymap.setView(latLng, 13);
      });
    }

    mapState.lat = lat;
    mapState.lng = long;
  }

  /**
   *
   * HTTP Call to fetch content of each section dynamicly
   * @param {string} sectionName - The name of the section to fetch ( determine by the `formState` object and the class asign via wordpress )
   * @param {string} itemValue  - The value of the previous item
   *
   * @returns {Promise} - Return a async Promise
   */
  function refreshContentData() {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open("POST", ajax_gf_params.ajaxurl, true);
      request.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=UTF-8"
      );
      request.onreadystatechange = (evt) => {
        if (
          evt.currentTarget.readyState === 4 &&
          evt.currentTarget.status === 200
        ) {
          try {
            const response = evt.currentTarget.response;
            resolve(response);
          } catch (exception) {
            reject(exception);
          }
        }
      };
      request.onerror = () => {
        reject(exception);
      };

      request.send(
        `action=update_radio_paths_geo&lat=${mapState.lat}&lng=${mapState.lng}&fieldId=${fieldId}`
      );
    });
  }

  function displayAllQueriesLocation(features) {
    const addressSelectionElement = document.querySelector(
      ".address-selection__single.is-hidden"
    );
    const wrapperElement = document.querySelector(
      ".address-selection-wrapper"
    );
    if (wrapperElement && addressSelectionElement) {
      wrapperElement.innerHTML = "";

      features.forEach((feature) => {
        if (feature.id.includes("address")) {
          const cloneSingle = addressSelectionElement.cloneNode(true);
          cloneSingle.classList.remove("is-hidden");
          cloneSingle.querySelector(
            ".address-selection__street"
          ).textContent = `${feature.address || ""} ${feature.text_fr || ""}`;
          feature.context.forEach((ctx) => {
            if (ctx.id.includes("postcode")) {
              cloneSingle.querySelector(
                ".address-selection__postal-code"
              ).textContent = `${ctx.text}`;
            }
            if (ctx.id.includes("place")) {
              cloneSingle.querySelector(
                ".address-selection__city"
              ).textContent = `${ctx.text}`;
            }
          });

          cloneSingle.dataset.address = feature.place_name;
          cloneSingle
            .querySelector(".address-selection__cta")
            .addEventListener("click", () => {
              setLongLat(feature.center[0], feature.center[1]);
              document.querySelector(".address-field__address-input").value = feature.place_name;
              scrollToMap();
            });
          wrapperElement.append(cloneSingle);
        }
        window.scrollObj.toEle('.address-selection-wrapper', 350, -100);
      });
    }
  }

  function setRadioClick() {
    const radioPathElement = document.querySelector('.radio_paths .ginput_container_radio');
    if (choosenPath && radioPathElement) {
      radioPathElement.querySelector(`input[value="${choosenPath}"`).checked = true;
    }
  }

  function setPathSelection() {
    const radioPathElement = document.querySelector('.radio_paths .ginput_container_radio');
    if (radioPathElement) {
      const radioElementList = radioPathElement.querySelectorAll('input[type="radio"]');
      Array.from(radioElementList).forEach(radio => {
        radio.addEventListener('change', () => {
          if (radio.checked) {
            choosenPath = radio.value;
          }
        });
      });
    }
  }

  function scrollToMap() {
    const map = document.querySelector('#mapid');
    window.scrollObj.toEle(map, 350, -100);
  }

  /**
   * jQuery handler to detect "page" changed and refetch all the needed data
   */
  if (jQuery) {
    jQuery(document).on("gform_post_render", (event, form_id, current_page) => {
      if (document.querySelector("#mapid")) {
        onInitMap();
        if (parseInt(current_page, 10) >= 2) {
          const radioPathElement = document.querySelector('.radio_paths .ginput_container_radio');
          radioPathElement.classList.add('is-loading');
          refreshContentData().then((response) => {
            const data = !!response ? JSON.parse(response) : {};
            radioPathElement.classList.remove('is-loading');
            const radioElement = document.querySelector(
              '.radio_paths ul.gfield_radio'
            );
            if (radioElement && data && data.radio_paths) {
              radioElement.innerHTML = data.radio_paths;
              document.querySelector('.form-header.no-results').classList.add('d-none');
              document.querySelector('.form-header.has-results').classList.remove('d-none');
              setRadioClick();
              setPathSelection();
            } else if(radioElement && (!response || !data.radio_paths)) {
              document.querySelector('.form-header.no-results').classList.remove('d-none');
              document.querySelector('.form-header.has-results').classList.add('d-none');
              document.querySelectorAll('.gform_page')[1].querySelector('.gform_page_footer').classList.add('d-none');
              radioElement.innerHTML = '';
            }
          });
        }
      }
    });
  }
});
